import {
  MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS,
  STEP_TO_ICON,
} from "Components/Hunter/Merchants/CompleteRegistration/steps";
import type { MerchantDetailDto } from "Infrastructure/Api/Api";
import { MerchantCompleteRegistrationPageStepper } from "Components/Hunter/Merchants/CompleteRegistration/MerchantCompleteRegistrationPageStepper";
import { MerchantCompleteRegistrationPageSkeleton } from "Components/Hunter/Merchants/CompleteRegistration/MerchantCompleteRegistrationPageSkeleton";
import { Resources, useResource } from "Translations/Resources";
import { useSearchParams } from "Navigation/useSearchParams";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useMerchantCompleteRegistrationPageStepsCompletionStatus } from "Components/Hunter/Merchants/CompleteRegistration/hooks/useMerchantCompleteRegistrationPageStepsCompletionStatus";
import { canStepBeActivated } from "Components/Shared/Stepper/utils";

const ComponentResources = Resources.Hunter.Merchants.CompleteRegistration;

type Props = {
  merchantDetail: MerchantDetailDto;
};

export const MerchantCompleteRegistrationPageInitializer = ({
  merchantDetail,
}: Props) => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();

  const { completionStatus, isLoading } =
    useMerchantCompleteRegistrationPageStepsCompletionStatus(
      merchantDetail.party.publicID || "",
      merchantDetail.publicID,
    );

  if (isLoading) {
    return <MerchantCompleteRegistrationPageSkeleton />;
  }

  if (!completionStatus) {
    return <ErrorText>{t(ComponentResources.LoadingError)}</ErrorText>;
  }

  const steps = MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS.map((id) => ({
    id,
    label: t(ComponentResources.Steps[id]),
    isCompleted: completionStatus[id],
    icon: STEP_TO_ICON[id],
  }));

  const activeStepIdFromParams = searchParams.get("activeStep");
  const canActivateParamsStep = canStepBeActivated(
    steps,
    steps.findIndex(({ id }) => id === activeStepIdFromParams),
  );
  const activeStepIndex =
    activeStepIdFromParams && canActivateParamsStep
      ? steps.findIndex(({ id }) => id === activeStepIdFromParams)
      : steps.findLastIndex((_, index) => canStepBeActivated(steps, index));

  return (
    <MerchantCompleteRegistrationPageStepper
      steps={steps}
      activeStepIndex={activeStepIndex ?? 0}
      merchantDetail={merchantDetail}
    />
  );
};
